// App route endpoint constants
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const PROFILE = '/profile';
export const PASSWORD_RESET = '/passwordreset';
export const ALBUM_CHART_ITEM = '/charts/album/:title';
export const TRACK_CHART_ITEM = '/charts/track/:title';
export const ALBUM_FAV_ITEM = '/account/favourites/album/:title';
export const TRACK_FAV_ITEM = '/account/favourites/track/:title';
export const LANDING = '/';
export const CHARTS = '/charts';
export const SEARCH = '/search';
export const SEARCH_ARTIST = '/search/artist/:name';
export const SEARCH_ALBUM = '/search/album/:title';
export const SEARCH_TRACK = '/search/track/:title';
export const SEARCH_ARTIST_ALBUM = '/search/artist/:artist/album/:title';



// WEBPACK FOOTER //
// ./src/constants/routes.js